import { createSlice } from "@reduxjs/toolkit";
import { savePartnerKey, saveIsOrthodox, saveIsMinor, saveShowOldClalit, getShowOldClalit, PARTNER_KEYS } from "../utils/partner";

const initialState = {
  partner: PARTNER_KEYS.NONE,
  isOrthodox: true,
  isMinor: false,
  venueData: {},
  // Hydrated at store construction, unlike isOrthodox above, so this render's value is already
  // the last one the server sent rather than a placeholder the handshake overwrites post-paint.
  // isV2Enabled reads it during render in ~33 places, so a wrong first frame is a visible flash.
  // Same shape as userSlice's hydrateClientAddress.
  showOldClalit: getShowOldClalit(),
};

const partnerSlice = createSlice({
  name: "partnerSlice",
  initialState,
  reducers: {
    setPartner: (state, action) => {
      const partnerId = action.payload;
      state.partner = partnerId;
      savePartnerKey(partnerId);
    },
    resetPartner: (state) => {
      state.partner = PARTNER_KEYS.NONE;
    },
    setIsOrthodox: (state, action) => {
      state.isOrthodox = action.payload;
      saveIsOrthodox(action.payload);
    },
    resetIsOrthodox: (state) => {
      state.isOrthodox = true;
    },
    // ShowOldClalit arrives on the Getuserdata response. Persisting from the reducer is the
    // setPartner/savePartnerKey precedent: one write site, so the store and localStorage cannot
    // disagree.
    setShowOldClalit: (state, action) => {
      state.showOldClalit = action.payload;
      saveShowOldClalit(action.payload);
    },
    setIsMinor: (state, action) => {
      state.isMinor = action.payload;
      saveIsMinor(action.payload);
    },
    resetIsMinor: (state) => {
      state.isMinor = false;
    },
    setVenueData: (state, action) => {
      state.venueData = action.payload;
    },
  },
});

export const { setPartner, resetPartner, setIsOrthodox, setIsMinor, resetIsOrthodox, setShowOldClalit, setVenueData } =
  partnerSlice.actions;

export const selectPartner = (state) => state.partnerSlice.partner;
export const selectIsOrthodox = (state) => state.partnerSlice.isOrthodox;
export const selectIsMinor = (state) => state.partnerSlice.isMinor;
export const selectShowOldClalit = (state) => state.partnerSlice.showOldClalit;
export const selectVenueData = (state) => state.partnerSlice.venueData;

//
export const isPartnerClalit = (state) => state.partnerSlice.partner === PARTNER_KEYS.CLALIT;
export const isPartnerMehudet = (state) => state.partnerSlice.partner === PARTNER_KEYS.MEHUDET;
export const isPartnerOvdimBari = (state) => state.partnerSlice.partner === PARTNER_KEYS.OVDIM_BARI;
export const isPartnerLeumit = (state) => state.partnerSlice.partner === PARTNER_KEYS.LEUMIT;
export const isPartnerMaoflaamit = (state) => state.partnerSlice.partner === PARTNER_KEYS.MAOFLAAMIT;
export const isPartnerNone = (state) => state.partnerSlice.partner === PARTNER_KEYS.NONE;

export default partnerSlice.reducer;
